import React, { useState } from 'react';
import { useJobGroupsWithTitles } from '@repository/codes/useCodes';
import Position from '@components/phs/test/jobPositionList/Position';
import classnames from 'classnames/bind';
import styles from './jobPositionList.module.scss';
import { usePhsCenterPosition } from '@repository/phs/center/usePhsCenter';
const cx = classnames.bind(styles);

const JobPositionList = () => {
  const [jobTitleCode, setJobTitleCode] = useState<number | undefined>(undefined);
  const { data: jobGroupTitlesData } = useJobGroupsWithTitles();
  const { data: positionData } = usePhsCenterPosition({ page: 0, size: 12, jobTitleCode });

  const getJobGroupTitleEls = () => {
    const jobTitles = jobGroupTitlesData?.find((jobGroupTitle) => jobGroupTitle.code === 13)?.jobTitles || [];
    const allTitle = { code: undefined, name: '전체' };
    return [allTitle, ...jobTitles].map((jobTitle, index) => {
      const handleClick = () => setJobTitleCode(jobTitle.code);
      return (
        <a
          key={index}
          className={cx('btnJob', { on: jobTitleCode === jobTitle.code })}
          role="button"
          onClick={handleClick}
        >
          {jobTitle.name}
        </a>
      );
    });
  };

  return (
    <div className={cx('jobPositionListArea')}>
      {/* 타이틀 영역 */}
      <strong className={cx('title')}>잡다에서 모집 중인 개발자 포지션을 모아봤어요.</strong>

      {/* 직무 리스트 영역 */}
      <div className={cx('jobListArea')}>{getJobGroupTitleEls()}</div>

      {/* 포지션 리스트 영역 */}
      <Position positions={positionData?.positions} />
    </div>
  );
};

export default JobPositionList;
